"use client";

import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";

/** Shown in the cart sidebar when a one-click reorder could not be prepared. */
export function ReorderFailed() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <IconAlertTriangle className="size-12 text-destructive" data-testid="reorder-failed-icon" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="space-y-1"><p className="text-lg font-medium text-foreground">We couldn't prepare your reorder</p><p className="text-sm">Try reordering from your order history.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div role="alert" data-testid="reorder-failed" className="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center text-muted-foreground">{t0}{t1}<Button variant="outline" asChild={true}><Link href="/account/orders">View order history</Link></Button></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}